import React, { ReactNode } from 'react';
import { AlignLeftOutlined, PlayCircleOutlined, FunctionOutlined } from '@ant-design/icons';
import ArrowWhiteRightIcon from 'img/arrow-right-white.svg';
import { MESSAGES } from 'pages/new-questions/components/DecisionTreeQuestion/utils/constants';
import { Button, Footer, Row } from 'pages/new-questions/styles/common';
import { QuestionPhase } from '../../utils/types';

interface SubmitFooterProps {
  currentIndex: number;
  totalSteps: number;
  selectedOption: number | null;
  onSubmit: () => void;
  BackButton?: ReactNode;
  phase: QuestionPhase;
  finished: boolean;
  waitingFinalSubmit?: boolean;
  hasCommentedQuestion?: boolean;
  hasVideoEmbed?: boolean;
  hasFormula?: boolean;
  onReadResolution?: () => void;
  onWatchResolution?: () => void;
  onShowFormula?: () => void;
}

export const SubmitFooter: React.FC<SubmitFooterProps> = ({
  currentIndex,
  totalSteps,
  selectedOption,
  onSubmit,
  BackButton,
  phase,
  finished,
  waitingFinalSubmit = false,
  hasCommentedQuestion,
  hasVideoEmbed,
  hasFormula,
  onReadResolution,
  onWatchResolution,
  onShowFormula,
}) => {
  const isLastQuestion = currentIndex >= totalSteps - 1;
  const buttonText = isLastQuestion ? MESSAGES.FINISH_AND_VIEW_RESULTS : MESSAGES.NEXT_QUESTION;
  const showSubmitButton = (phase === 'single' || waitingFinalSubmit) && !finished;
  const disableSubmitButton = !waitingFinalSubmit && !selectedOption;

  return (
    <Footer borderTop={phase === 'single' ? '1px solid #efefef' : 'none'}>
      <Row width="100%" maxWidthTransformCol="1040px">
        {BackButton && <Row maxWidthTransformCol="1040px">{BackButton}</Row>}
        <Row maxWidthTransformCol="1040px">
          {hasCommentedQuestion && onReadResolution && (
            <Button
              styles="secondary"
              onClick={onReadResolution}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <AlignLeftOutlined /> Ler Resolução
            </Button>
          )}
          {hasVideoEmbed && onWatchResolution && (
            <Button
              styles="secondary"
              onClick={onWatchResolution}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <PlayCircleOutlined /> Assistir Resolução
            </Button>
          )}
          {hasFormula && onShowFormula && (
            <Button
              styles="secondary"
              onClick={onShowFormula}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <FunctionOutlined /> Fórmula
            </Button>
          )}
        </Row>
        {showSubmitButton && (
          <Button
            styles="primary"
            onClick={onSubmit}
            disabled={disableSubmitButton}
            margin="0 0 0 auto"
          >
            {buttonText}
            <img src={ArrowWhiteRightIcon} alt="Next" />
          </Button>
        )}
      </Row>
    </Footer>
  );
};
